import styled from 'styled-components/macro';

import {useState} from "react";
import {
    Alert,
    AlertIcon,
    AlertTitle,
    Button,
    Checkbox,
    FormControl,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea
} from "@chakra-ui/react";
import {useFeedback} from "../../store/feedback";
import {useBan, useBanStatus} from "../../api/moderation";

const Ban = styled(({post, comment, onClose}) => {
    const {feedbackCh, busy} = useFeedback();
    const author = post ? post.author : comment.author;
    const community = post ? post.community : comment.community;
    const banStatus = useBanStatus(feedbackCh, author, community)?.banned;
    const [days, setDays] = useState('');
    const [reason, setReason] = useState('');
    const [nuke, setNuke] = useState(false);
    const [ipBan, setIpBan] = useState(false);
    const ban = useBan(feedbackCh);
    const [isBanning, setIsBanning] = useState(false);
    const handleBan = async () => {
        try {
            setIsBanning(true);
            await ban(author, community, reason, days ? days : 0, ipBan, nuke);
        } catch {}
        setIsBanning(false);
        onClose();
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Ban u/{author}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        {banStatus && <Alert status="error">
                            <AlertIcon />
                            <AlertTitle mr={2}>User is already banned.</AlertTitle>
                        </Alert>}

                        <FormControl>
                            <FormLabel>Days</FormLabel>
                            <Input placeholder="" value={days} type="number"
                                   onChange={(e) => setDays(e.currentTarget.value)}/>
                            <FormHelperText>Leave this blank for a permanent ban.</FormHelperText>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Reason</FormLabel>
                            <Textarea type="reason" value={reason} rows={5}
                                      onChange={(e) => setReason(e.currentTarget.value)}
                            />
                            <FormHelperText>User will see this message.</FormHelperText>
                        </FormControl>

                        <Checkbox size='sm' value={nuke}
                                  onChange={(e) => setNuke(e.target.checked)}>Nuke (remove all content)</Checkbox>

                        <Checkbox size='sm' value={ipBan}
                                  onChange={(e) => setIpBan(e.target.checked)}>IP Ban</Checkbox>

                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" disabled={banStatus} isLoading={isBanning} onClick={handleBan}>
                        Ban
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})``;

export default Ban;
